export type SuccessListItemType = {
  title: string;
  name: string;
  qualification: string;
  image: string;
  avatar: string;
  content: string;
  slug: string;
};

export type SlugType = "tatishchev" | "dzhavadov";

export const SUCCESS_LIST: SuccessListItemType[] = [
  {
    title: "tatishchev.title",
    name: "tatishchev.name",
    qualification: "tatishchev.qualification",
    image: "/images/success-story/tatishchev/detail/header.png",
    avatar: "/images/success-story/tatishchev/avatar.png",
    content: "tatishchev.content",
    slug: "tatishchev",
  },
  {
    title: "dzhavadov.title",
    name: "dzhavadov.name",
    qualification: "dzhavadov.qualification",
    image: "/images/success-story/dzhavadov/detail/header.png",
    avatar: "/images/success-story/dzhavadov/avatar.png",
    content: "dzhavadov.content",
    slug: "dzhavadov",
  },
];
